<script setup>
const { t } = useI18n()
</script>

<template>
  <BaseLink
    url="/appointment_types"
    :v2-link="true"
    class="mx-4 block md:self-start"
  >
    <div class="appointment-btn btn-md flex flex-row items-center justify-center flex-gap-x-2 uppercase lt-md:w-full md:w-fit btn-fill-primary">
      <DSIcon
        icon="i-far-user-clock"
        class="mr-2 items-center"
        size="24"
      />
      <span>{{ t('Schedule Appointment') }}</span>
    </div>
  </BaseLink>
</template>

<i18n>
{
  "en-us": {
    "Schedule Appointment": "Schedule Appointment"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Schedule Appointment": "Termin vereinbaren"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Schedule Appointment": "Planifier un rendez-vous"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Schedule Appointment": "Programar cita"
}
</i18n>
